export default {
    computed: {
        getPrice(){
            return (product, category) =>  product.price + (category.surcharge ? category.surcharge : 0)
        }
    }
}
